import React from 'react';
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { FaCheckSquare } from 'react-icons/fa';
import { FaMinusSquare } from 'react-icons/fa';

const ItemsStatus = ({itemQuantity, itemQuantityReturnedOk, itemQuantityReturnedDamaged}) => {
    if (!itemQuantity || itemQuantity < 0) {
        return null;
    }

    const itemStatus = [...Array(itemQuantity)].map((status, index) => {
        if (index < itemQuantityReturnedOk) {
            return 1;
        }
        else if (index >= itemQuantityReturnedOk && index < itemQuantityReturnedOk + itemQuantityReturnedDamaged) {
            return 2;
        }
        else {
            return 0;
        }
    });

    //console.log("itemStatus: ", itemStatus);

    return (
        <span>
            {itemStatus.map((status, index) => 
                <SwitchTransition key={"status_" + index} mode="out-in">
                    <CSSTransition
                        key={status}
                        addEndListener={(node, done) => {
                            node.addEventListener("transitionend", done, false);
                        }}
                        classNames="changeStatus"
                    >
                        {
                            {
                                0: <FaCheckSquare style={{ color: "lightgray" }}/>,
                                1: <FaMinusSquare style={{ color: "purple" }}/>,
                                2: <FaMinusSquare style={{ color: "purple" }}/>
                            }[status]
                        }
                    </CSSTransition>
                </SwitchTransition>
            )}
        </span>
    );
}
 
export default ItemsStatus;